/*
 * @Author: Teemo Ding
 * @Date: 2021-09-24 09:53:57
 * @LastEditTime: 2021-09-28 09:39:49
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/DestinationAddressLocalisation/Singapore/index.tsx
 */

import { Button, Select } from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import { DeleteOutlined, QuestionCircleFilled } from '@ant-design/icons';
import { Form } from 'antd';
import React from 'react';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from '../css.module.less';

//import { values } from 'lodash';

const RenderSupportedLanguage = ({
  fields,
  allLanguages,
  notEditable,
  add,
  remove,
  form,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const handleOnDel = (i) => {
    remove(i);
    const subdivisions = form.getFieldValue('subdivisions');
    subdivisions.splice(i, 1);
    form.setFieldsValue({ subdivisions });
  };
  const handelOnAdd = () => {
    add('');
    const subdivisions = form.getFieldValue('subdivisions');
    const subdivisionList = subdivisions[0].subdivisions.map((item) => ({
      ...item,
    }));
    const defaultSubdivision = { locale: '', subdivisions: subdivisionList };
    subdivisions.push(defaultSubdivision);
    form.setFieldsValue({
      subdivisions,
    });
  };
  const handleSelectOnchange = (value, index) => {
    const subdivisions = form.getFieldValue('subdivisions');
    subdivisions[index].locale = value;
    form.setFieldsValue({
      subdivisions,
    });
  };

  const singapore = form.getFieldValue('supportedLanguage');
  const allLanguagesOption = allLanguages
    .filter((o) => !(singapore || []).includes(o.languageTag))
    .map((item) => ({
      value: item.languageTag,
      label: `${item.description} - ${item.languageTag}`,
    }));

  return (
    <div>
      {fields.map(
        ({ key, name, fieldKey, ...restField }, index) =>
          index > 0 && (
            <div key={key} className={styles.selectorOptions}>
              <div className={styles.input}>
                <Form.Item
                  {...restField}
                  name={name}
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        'storeLogistics.destinationAddressLocalisation.supportedLanguageCannotEmpty',
                      ),
                    },
                  ]}>
                  <Select
                    size='large'
                    disabled={notEditable}
                    onChange={(value) => handleSelectOnchange(value, index)}
                    optionsList={allLanguagesOption}
                  />
                </Form.Item>
              </div>
              {!notEditable && (
                <i className={`${styles.icon} ${styles.delete}`}>
                  <Button onClick={() => handleOnDel(key)} type='text'>
                    <DeleteOutlined />
                  </Button>
                </i>
              )}
            </div>
          ),
      )}
      {!notEditable && (
        <div onClick={handelOnAdd} className={styles.add}>
          <Icon type='iconplus' />
          {getI18n(
            'storeLogistics.destinationAddressLocalisation.addothersupportedlanguage',
          )}
        </div>
      )}
    </div>
  );
};

const Singapore = ({ allLanguages, form, notEditable }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.itemBlock}>
      <div className={styles.header}>
        <div className={styles.title}>
          {getI18n('storeLogistics.destinationAddressLocalisation.singapore')}
        </div>
      </div>
      <div className={`${styles.singapore} ${styles.content}`}>
        <Form.Item
          label={
            <div>
              {getI18n(
                'storeLogistics.destinationAddressLocalisation.deliveryAddressDefaultLanguage',
              )}
              <WhiteBackgroundTooltip
                overlayClassName={styles.overlayClassName}
                title={
                  <TooltipContainer>
                    <TooltipTitle>
                      {getI18n(
                        'storeLogistics.destinationAddressLocalisation.defaultLanguage',
                      )}
                    </TooltipTitle>
                    <TooltipContent>
                      {getI18n(
                        'storeLogistics.destinationAddressLocalisation.defaultLanguageTips',
                      )}
                    </TooltipContent>
                  </TooltipContainer>
                }
                placement='rightTop' //overlayClassName
              >
                <QuestionCircleFilled className={styles.icon} />
              </WhiteBackgroundTooltip>
            </div>
          }
          name='defaultLanguage'>
          {getI18n('storeLogistics.destinationAddressLocalisation.englishen')}
        </Form.Item>
        <div className={styles.supportedLanguageLabel}>
          {getI18n(
            'storeLogistics.destinationAddressLocalisation.supportedLanguageLabel',
          )}
        </div>
        <Form.List name='supportedLanguage'>
          {(fields, { add, remove }) => (
            <RenderSupportedLanguage
              notEditable={notEditable}
              fields={fields}
              add={add}
              remove={remove}
              allLanguages={allLanguages}
              form={form}
            />
          )}
        </Form.List>
      </div>
    </div>
  );
};

export default Singapore;
